import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogBoundryService } from '@secca/core/services/dialog-boundry.service';
import { DialogHelperUtilService } from '@secca/core/services/dialog-helper-util.service';
import { AtlasFraudDetectionRulesDialogComponent } from '@secca/shared/components/atlas-chatbot/fraud-detection-rules-dialog/atlas-fraud-detection-rules-dialog.component';

@Component({
  selector: 'app-atlas-chatbot-info-dialog',
  templateUrl: './atlas-chatbot-info-dialog.component.html',
  styleUrls: ['./atlas-chatbot-info-dialog.component.scss'],
  standalone: false
})
export class AtlasChatbotInfoDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<AtlasChatbotInfoDialogComponent>,
    public dialogBoundryService: DialogBoundryService,
    private dialogHelperUtilService: DialogHelperUtilService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  openFraudDetectionRulesDialog(): void {
    this.dialogHelperUtilService.open(AtlasFraudDetectionRulesDialogComponent, {
      id: 'AtlasFraudDetectionRulesDialog',
      width: '860px',
      position: {},
      hasBackdrop: false
    });
  }
}
